import { isDesktop, openExternal, PUBLIC_WEB_URL } from "../lib/desktop.ts";

/** Required by Mojang's usage guidelines wherever MC Planner is presented. */
export const DISCLAIMER = "NOT AN OFFICIAL MINECRAFT PRODUCT. NOT APPROVED BY OR ASSOCIATED WITH MOJANG OR MICROSOFT.";

/** Static pages in apps/web/public/legal (served next to the app). */
const PAGES: [string, string][] = [
  ["legal/index.html", "Legal notice"],
  ["legal/privacy.html", "Privacy"],
  ["legal/terms.html", "Terms"],
];

/** A link to one of the legal pages (in the desktop app it opens the website in the browser). */
export function LegalLink({ path, children }: { path: string; children: React.ReactNode }) {
  const desktop = isDesktop();
  const href = desktop ? PUBLIC_WEB_URL + path : "./" + path;
  return <a href={href} target="_blank" rel="noopener" onClick={desktop ? (e) => { e.preventDefault(); void openExternal(href); } : undefined}>{children}</a>;
}

/** Legal links + the Minecraft disclaimer (setup screen, shortcut overview). */
export function LegalFooter() {
  const desktop = isDesktop();
  return (
    <div className="legal-footer tiny">
      <nav aria-label="Legal">
        {PAGES.map(([path, label]) => {
          // the desktop app must not navigate its own window away from the app: open the website in the browser
          const href = desktop ? PUBLIC_WEB_URL + path : "./" + path;
          return (
            <a key={path} href={href} target="_blank" rel="noopener" onClick={desktop ? (e) => { e.preventDefault(); void openExternal(href); } : undefined}>
              {label}
            </a>
          );
        })}
      </nav>
      <p className="muted">{DISCLAIMER}</p>
    </div>
  );
}
